import StandardQueryTable from "@/components/StandardQueryTable";
import DictionaryCreator from "@/components/dictionaries/DictionaryCreator";
import DictionaryEditor from "@/components/dictionaries/DictionaryEditor";
import { PATH_DICTS_STORE_FORMATS } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import { readStoreFormat, writeStoreFormat } from "@/schemas/storeFormat";
import { StoreFormatsService } from "@/services/storeFormat";
import { ReadStoreFormat, WriteStoreFormat } from "@/types/storeFormat";
import { Store } from "lucide-react";

const id = Module.StoreFormats;
const path = PATH_DICTS_STORE_FORMATS;
const ns = "storeFormats";

const config: DictionaryConfig<ReadStoreFormat, WriteStoreFormat> = {
  id,
  ns,
  service: StoreFormatsService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeStoreFormat,
  defaultValues: { name: "", description: "" },
  Icon: Store,
  List: () => (
    <StandardQueryTable<ReadStoreFormat>
      schema={readStoreFormat}
      name={ns}
      fetchList={StoreFormatsService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.StoreFormats },
      }}
    />
  ),
  Creator: DictionaryCreator,
  Editor: DictionaryEditor,
};

export default config;
